module.exports = __webpack_public_path__ + "img/bg_1.c8781825.png";